import { ITrackedClass } from '@models/interfaces/tracked-class';

const changedItems = new Set<ITrackedClass>();
const deletedItems = new Set<ITrackedClass>();

/** This class syncs changes to the renderer to update the scene view */
export class SyncService {
    static registerChangedState(tracker: ITrackedClass, modified: boolean) {
        if (modified) {
            // If node was deleted, ignore further changes, unless the item was moved to a different parent
            if (!deletedItems.has(tracker) || tracker.changes.has('_parent')) {
                changedItems.add(tracker);
            }
        } else {
            changedItems.delete(tracker);
        }
    }
    // When a new object is being created, the proxy being used to set the values will be the proxy of the parent of the class being created.
    // So, we need to make sure the changed items map is always pointing to the correct proxy (the proxy with the highest specificity)
    static registerNewObject(tracker: ITrackedClass) {
        changedItems.add(tracker);
    }
    static registerDeleted(tracker: ITrackedClass) {
        deletedItems.add(tracker);
    }

    static get hasChanges() {
        return changedItems.size > 0 || deletedItems.size > 0;
    }
    static getChangedNodes() {
        return [...changedItems.values()];
    }
    static getDeletedNodes() {
        return [...deletedItems.values()];
    }

    static nodeDeletionProcessed(tracker: ITrackedClass) {
        //when a node is deleted, we remove it from all the maps
        changedItems.delete(tracker);
        deletedItems.delete(tracker);
    }

    static nodeChangesProcessed(tracker: ITrackedClass) {
        //when node changes have been processed, we only remove it from the changedItems map
        changedItems.delete(tracker);
    }
}
